/* eslint-disable no-param-reassign */

export default
{
  customClassConfirmacao: corCancelar => ({
    confirmButton: 'btn  btn-primary mr-50',
    // cancelButton: `btn ${tipo === 'danger' ? 'btn-danger' : 'btn-warning'}`,
    cancelButton: `btn btn-${corCancelar}`,
  }),

  install(Vue) {
    const confirmar = (titulo, mensagem, tipo, corCancelar) => {
      if (tipo === 'success') {
        return Vue.swal({
          title: titulo,
          text: mensagem,
          width: 600,
          icon: tipo,
          showCancelButton: false,
          confirmButtonText: 'Ok',
          customClass: {
            confirmButton: 'btn w-50 btn-success',
          },
          buttonsStyling: false,
        })
      }
      return Vue.swal({
        title: titulo,
        text: mensagem,
        icon: tipo,
        showCancelButton: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        customClass: this.customClassConfirmacao(corCancelar),
        buttonsStyling: false,
      })
    }
    Vue.prototype.$confirmar = confirmar

    const confirmarHtml = (titulo, mensagem, tipo, corCancelar) => {
      if (tipo === 'success') {
        return Vue.swal({
          title: titulo,
          html: mensagem,
          icon: tipo,
          showCancelButton: false,
          confirmButtonText: 'Ok',
          customClass: {
            confirmButton: 'btn w-50 btn-success',
          },
          buttonsStyling: false,
        })
      }
      return Vue.swal({
        title: titulo,
        html: mensagem,
        icon: tipo,
        showCancelButton: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
        customClass: this.customClassConfirmacao(corCancelar),
        buttonsStyling: false,
      })
    }
    Vue.prototype.$confirmarHtml = confirmarHtml

    const atencao = (titulo, mensagem, textoBotao) => Vue.swal({
      title: titulo,
      text: mensagem,
      icon: 'warning',
      showCancelButton: false,
      confirmButtonText: textoBotao,
      customClass: {
        confirmButton: 'btn w-50 btn-success',
      },
      buttonsStyling: false,
    })
    Vue.prototype.$atencao = atencao

    const atencaoHtml = (titulo, mensagem, textoBotao) => Vue.swal({
      title: titulo,
      html: mensagem,
      icon: 'warning',
      showCancelButton: false,
      confirmButtonText: textoBotao,
      customClass: {
        confirmButton: 'btn w-50 btn-success',
      },
      buttonsStyling: false,
    })
    Vue.prototype.$atencaoHtml = atencaoHtml
  },
}
